'use client';
import { Skeleton } from '../../../components/ui';

export function AchievementGridSkeleton({ count = 8 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 p-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="flex flex-col items-center gap-2 p-3 rounded-2xl bg-fill-tertiary">
          <Skeleton className="aspect-square w-full rounded-xl" />
          <Skeleton className="w-20 h-3.5 rounded-md" />
          <Skeleton className="w-24 h-3 rounded-md" />
        </div>
      ))}
    </div>
  );
}
